import { useAccount, useSignMessage } from 'wagmi';
import { HexString } from '@/lib/config/wagmi';
import { storeSession } from '@/lib/hooks/useSession';
import { getNowTimestamp } from '@/lib/utils/day.utils';
import { requestWalletLogin } from '@/lib/services/account.service';

export function useSignLogin() {
  const { signMessageAsync } = useSignMessage();
  const { address } = useAccount();
  const signLogin = async (): Promise<string> => {
    const nowTimestamp = getNowTimestamp();
    const rawMessage = `Hi! Welcome to heima.network. Please sign the message to let us know that you own the wallet. Signing is gas-less and will not give heima.network permission to conduct any transactions with your wallet. Timestamp is ${nowTimestamp}.`;
    if (!address) {
      throw new Error('address required');
    }
    const signRes: HexString = await signMessageAsync({
      message: rawMessage,
    });
    console.log(signRes);
    const loginRes = await requestWalletLogin({
      timestamp: nowTimestamp,
      signature: signRes,
      walletAddress: address,
    });
    //todo call api return token;
    await storeSession({
      key: address,
      type: 'wallet',
      accessToken: loginRes.accessToken,
    });
    return loginRes.accessToken;
  };
  return {
    signLogin,
  };
}
